export default "__VITE_PUBLIC_ASSET__13fe625b__"